import api from "./api";
import {
  AvailableParticipantCertificateDetail,
  ParticipantCertificateEmissionData,
  ParticipantCertificateListResponse,
  ParticipantCertificateDetailResponse,
  CertificateValidationData,
  SatisfactionSurveyAnswerPayload,
  SatisfactionSurveySubmissionResponse,
} from "../types/ParticipantCertificate";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Token nao encontrado");
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

export type AvailableParticipantCertificateFilters = {
  filtro?: string;
  ano?: string | number;
  anos?: Array<string | number>;
  document_type?: string;
  status?: string;
  search?: string;
  ordenacao?: string;
  modalidade?: string;
  tipo_acao?: string;
  tema?: string;
  data_inicio?: string;
  data_fim?: string;
};

export async function findAvailableParticipantCertificates(
  params: AvailableParticipantCertificateFilters = {},
): Promise<ParticipantCertificateListResponse> {
  const response = await api.get<ParticipantCertificateListResponse>("/certificados/disponiveis", {
    headers: getAuthHeaders(),
    params,
  });

  return response.data;
}

export async function findAvailableParticipantCertificateDetail(
  turmaId: string | number,
): Promise<AvailableParticipantCertificateDetail> {
  const response = await api.get<ParticipantCertificateDetailResponse>(`/certificados/disponiveis/${turmaId}`, {
    headers: getAuthHeaders(),
  });

  return response.data.data;
}

export async function emitParticipantCertificate(
  turmaId: string | number,
): Promise<ParticipantCertificateEmissionData> {
  const response = await api.post<{ success: boolean; data: ParticipantCertificateEmissionData }>(
    `/turmas/${turmaId}/certificado/emitir`,
    {},
    {
      headers: getAuthHeaders(),
    },
  );

  return response.data.data;
}

export async function reemitIssuedCertificate(
  codigo: string,
): Promise<ParticipantCertificateEmissionData> {
  const response = await api.post<{ success: boolean; data: ParticipantCertificateEmissionData }>(
    "/certificate-templates/certificados-emitidos/emitir",
    { codigo },
    {
      headers: getAuthHeaders(),
    },
  );

  return response.data.data;
}

export async function submitParticipantSatisfactionSurvey(
  turmaId: string | number,
  respostas: SatisfactionSurveyAnswerPayload[],
): Promise<SatisfactionSurveySubmissionResponse["data"]> {
  const response = await api.post<SatisfactionSurveySubmissionResponse>(
    `/turmas/${turmaId}/minha-pesquisa-satisfacao`,
    { respostas },
    {
      headers: getAuthHeaders(),
    },
  );

  return response.data.data;
}

export async function validateParticipantCertificate(
  codigo: string,
): Promise<CertificateValidationData> {
  const response = await api.get<CertificateValidationData>(`/certificados/validar/${encodeURIComponent(codigo)}`);

  return response.data;
}
